// extracted by mini-css-extract-plugin
export default {"banner":"improvement-banner_banner__pxv25"};